import type { FeatureFlagValueType } from '@brightdrop/feature-flags-client';
import type { NavBarItem } from '@gm-commercial/navbar-model';
import type { Profile } from '@gm-commercial/profile-model';

import UserIcon from '~/assets/icons/new/user.svg?react';
import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { RouteName } from '~/common/models/route.model';
import { findRoute, makeRoutePath } from '~/common/utils/route/route.utils';

const generateTestId = (
  base: string,
  value: string,
  suffix = 'nav-list-item'
) => {
  return `${base}-${value}-${suffix}`;
};
export const getUserNavBarItems = ({
  profileParams,
  displayIcon = false,
}: {
  profileParams: Profile['permissionsContextIds'];
  displayIcon?: boolean;
}): NavBarItem[] => {
  const context = {
    fleetsId: profileParams?.fleetsId || undefined,
    hubsId: profileParams?.hubsId || undefined,
    organizationsId: profileParams?.organizationsId || undefined,
  };
  return displayIcon
    ? [
        {
          label: translateText('common:user_plural'),
          testId: generateTestId('account', 'users', 'header'),
          icon: <UserIcon className="noFill" />,
          path: makeRoutePath(
            findRoute(RouteName.CS_PLATFORM_USER_LIST),
            context,
            true,
            false
          ),
        },
      ]
    : [
        {
          label: translateText('common:user_plural'),
          testId: generateTestId('account-organization', 'users'),
          path: makeRoutePath(
            findRoute(RouteName.CS_PLATFORM_USER_LIST),
            context,
            true,
            false
          ),
        },
      ];
};
